import { render, staticRenderFns } from "./partLoading.vue?vue&type=template&id=3bf47d46&scoped=true&"
import script from "./partLoading.vue?vue&type=script&lang=ts&"
export * from "./partLoading.vue?vue&type=script&lang=ts&"
import style0 from "./partLoading.vue?vue&type=style&index=0&id=3bf47d46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf47d46",
  null
  
)

export default component.exports